import { render, staticRenderFns } from "./AddNewCommentToOrder.vue?vue&type=template&id=40dcac23&scoped=true&"
import script from "./AddNewCommentToOrder.vue?vue&type=script&lang=js&"
export * from "./AddNewCommentToOrder.vue?vue&type=script&lang=js&"
import style0 from "./AddNewCommentToOrder.vue?vue&type=style&index=0&id=40dcac23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dcac23",
  null
  
)

export default component.exports